// 静态值定义： 【应用配置】

/**
 * [api 后端接口相关，自动根据打包命令加载对应环境接口地址]
 * @type {Object}
 */
export const env = {
  HOST_IP: process.env.HOST_IP,
  OA_HOST_IP: process.env.OA_HOST_IP,
  COMMENT_HOST_IP: process.env.COMMENT_HOST_IP,
  CALL_PATH: process.env.CALL_PATH,
  INVOKE_PATH: process.env.INVOKE_PATH,
  CONTEXT_PATH: process.env.CONTEXT_PATH,
  ENV_MODE: process.env.NODE_ENV, //环境模式
  STORE_LOG_SWITCH: true, //打印VUEX日志 (仅限开发环境有效)
  PRINT_DEBUG_URL: true, //打印HTTP请求URL (仅限开发环境有效)
};

export const wx = {
  APP_ID: 'wx5afd32ac14c76152',
  TEST_OPENID: '0C83B5471E4448BC86F52F5F9FADE9FAC14CB5AA3247D475B14BB818E719F468'
};

export default {
  env: env,
  apiBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + "/" + env.INVOKE_PATH,
  authBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + '/jsoncall/loginCall/getLoginToken',
  loginReqUrl: env.HOST_IP + "/" + env.CALL_PATH + "/jsoncall/loginCall/login",
  logoutBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + '/jsoncall/loginCall/logout',
  imgBaseUrl: env.HOST_IP + "/" + env.CALL_PATH,
  tokenCallUrl: env.HOST_IP,
  oaTokenCallUrl: env.OA_HOST_IP,
  commentTokenCallUrl: env.COMMENT_HOST_IP,
  uploadBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + "/f-ul",
  downloadBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + "/dlfile",
  onlinePreviewUrl: env.HOST_IP + '/mxoa/onlinePreview',
  wx: wx,
  versionNo: '1.0.0', //客户端版本号
  defaultVal: {
    qrcode: wx.QR_CODE
  },
  errorMsg: {
    "AccessPermissionDeny": '服务请求被拒绝，检查是否未登陆！',
    "InvalidSign": '鉴权失败，服务请求被拒绝！',
    "java.lang.IllegalStateException": '服务请求失败，请稍后再试！',
    "RuntimeException": '服务请求失败，请稍后再试！',
    "IllegalStateException": '服务请求失败，请稍后再试！',
    "InvalidService": '服务请求失败，请稍后再试！',
    "NoExporterException": '服务请求失败，请稍后再试！',
  },
}



// WEBPACK FOOTER //
// ./src/Constant.js